const hospitalTranslation = {
  mode: 'en',
  menu: 'Account',

  subscriptionManagementTitle: 'Subscription Management',
  subscriptionMenu: 'Subscription Management',
  subscriptionColumnsDuration: 'Subscription Duration (days)',
  subscriptionColumnsStartDate: 'Paid Barcode Date',
  subscriptionColumnsEndDate: 'Subscription End Date',
  subscriptionColumnsStatus: 'Subscription Status',
  subscriptionFilterLabel: 'Status Filter',
  subscriptionFilterSubscribed: 'Subscribed',
  subscriptionFilterUnsubscribed: 'Unsubscribed',
  subscriptionTagSubscribed: 'Subscribed',
  subscriptionTagUnsubscribed: 'Unsubscribed',
  subscriptionTagTotal: 'Total',
  subscriptionSearchPlaceholder: 'Search by name or sequence',
  subscriptionSearchResults: 'Results',
  subscriptionUpdateInvalid: 'Subscription duration must be at least one day.',
  subscriptionUpdateSuccess: 'Subscription duration updated successfully.',
  subscriptionUpdateFailure: 'Update failed',
  subscriptionUpdateError: 'An error occurred while updating the subscription duration.',
  subscriptionStartDateInvalid: 'Please enter a valid date',
  subscriptionStartDateUpdateSuccess: 'Start date has been updated successfully',
  subscriptionStartDateUpdateFailure: 'Failed to update start date',
  subscriptionStartDateUpdateError: 'An error occurred while updating the start date',
  subscriptionDurationTooltip: 'Enter between 1 and 3650 days',
  subscriptionDurationMaxLabel: 'Max 3650 days',
  subscriptionDaysUnit: '{{value}} days',

  hospitalTableTitle: 'Account List',
  addHospital: 'Add Account',
  addHospitalRoom: 'Add Location',
  addHospitalLogin: 'Add HPA Account',
  seq: 'Location Seq',
  name: 'Location',
  realName: 'Real Name',
  regionAlias: 'Region Alias',
  doctorName: 'Admin Name',
  hospitalName: 'Account Name',
  zipcode: 'Zip Code',
  address: 'Address',
  street: 'Street',
  lat: 'Latitude',
  lng: 'Longitude',
  city: 'City',
  province: 'State',
  telephone: 'Phone',
  deviceAlertPhone: 'MommyBox device alert phone (mobile only)',
  deviceAlertPhonePlaceholder: '+1 555 123 4567',
  deviceAlertPhoneInvalid: 'Enter a mobile number in local or international format.',
  description: 'Client Code',
  homepage: 'Homepage',
  paidBarcodeDate: 'Paid Barcode Date',
  viewable: 'Viewable on Upload',
  recording: 'Video',
  capture: 'Photo',
  hospitalPermission: 'Admin Permission',
  hospitalStatus: 'Hospital Status',
  uploadVisibilitySettings: 'Upload Visibility',
  nipt: 'NIPT',
  libre: 'LIBRE',
  qrPayment: 'QR Payment',
  isMaternity: 'Maternity Hospital',
  pinkBarcode: 'Pink Barcode Start Date',
  useNipt: 'Allow NIPT',
  useLibre: 'Allow LIBRE',
  useBabyMagic: 'Allow BabyView AI',
  useQrPayment: 'Allow QR Payment',
  crystalReveal: 'CrystalReveal',
  crystalRevealMode: 'CrystalReveal Mode',
  crystalRevealNone: 'Disabled',
  crystalRevealBasic: 'Basic',
  crystalRevealFull: 'Full',
  activeFlag: 'Active Status',
  activeStatus: 'Active?',
  active: 'Active',
  inactive: 'Inactive',
  activeHospital: 'Active Account',
  inactiveHospital: 'Inactive Account',
  streamingStop: 'Stop Streaming',
  streamingStopped: 'Stopped',
  streaming: 'Streaming',
  id: 'ID',
  password: 'Password',
  permission: 'Permission',

  statistics: 'Account Performance',
  dailyMonthlyStatistics: 'Daily/Monthly Peformance',
  dailyMonthlyUltrasoundStatistics: 'Daily/Monthly Session Recorded',
  dailyStatistics: 'Daily Performance',
  monthlyStatistics: 'Monthly Performance',
  dailyBarcodeCount: 'Daily Barcode Recorded',
  dailyVideoLengthAvg: 'Daily Average Video Length',
  monthlyBarcodeCount: 'Monthly Barcode Recorded',
  monthlyVideoLengthAvg: 'Monthly Average Video Length',

  record: 'Records',
  detailRecord: 'Detailed Records',

  videoPlay: 'View Contents',
  videoDetailSearch: 'Search Contents',
  videoDownload: 'Download Contents',
  deviceList: 'View Device',
  niptAdmin: 'NIPT',
  libreAdmin: 'LIBRE',
  telemedicineAdmin: 'Telemedicine',
  statsDisplay: 'Dashboard',
  medicalRecordDisplay: 'Chart',
  videoBlind: 'Hide/Unhide Contents',

  saveInfo: 'Save',
  info: 'Account Information',
  hospitalInfo: 'Hospital Information',
  billingInfo: 'Billing Information',
  hospitalRoomInfo: 'Location',
  hospitalLoginInfo: 'HPA Account',
  editHospitalInfo: 'Edit Account Information',
  noRawPassword: 'No Text',
  passwordIssuedByEmail: 'Temporary password will be emailed after save.',

  loginWarningMessage: 'ID already in use.',
  idEmailFormatMessage: 'ID must be entered in email format.',
  idEmailPlaceholder: 'example@hospital.com',
  loginErrorMessage: 'Error: Failed to update. Please contact the administrator.',
  loginEmailSuccessMessage: 'The account was created and the email was sent.',
  loginEmailSuccessDescription: 'Please ask the hospital administrator to check their email.',
  loginEmailWarningMessage: 'The account was created, but the email could not be sent.',
  loginEmailWarningDescription:
    'Please share the password with the hospital administrator separately.',
  deleteHospitalRoomMessage: 'Do you want to delete this location?',
  deleteLoginMessage: 'Do you want to delete this HPA account?',

  // Popup Target Management
  popupTargetManagement: 'Popup Target Management',
  popupTargetManagementDesc: 'Manage hospitals that will receive popups',
  hospitalList: 'Hospital List',
  hospitalSeq: 'HospitalSeq',
  popupTargetStatus: 'Popup Target Status',
  isPopupTarget: 'Target',
  notPopupTarget: 'Not Target',
  selectHospitalFirst: 'Please select a hospital first',
  selectHospitalToAdd: 'Select hospital to add',
  addTarget: 'Add Target',
  removeTarget: 'Remove Target',
  totalTargets: 'Total Targets',

  addTargetSuccess: 'Hospital added to popup targets successfully',
  removeTargetSuccess: 'Hospital removed from popup targets successfully',
  removeTargetConfirm: 'Are you sure you want to remove this hospital from popup targets?',
  removeTargetDescription: 'This hospital will no longer receive popups',

  // Filter and Statistics
  filterByStatus: 'Filter by Status',
  showAll: 'Show All',
  showTargets: 'Targets Only',
  showNonTargets: 'Non-targets Only',
  targetCount: 'Target Hospitals',
  totalCount: 'Total Hospitals',
  searchHospitalPlaceholder: 'Search by hospital name or number',
  searchResults: 'Search Results',

  popupContent: 'Popup Content',
  popupType: 'Popup Type',
  popupStatus: 'Status',
  targetHospital: 'Target Hospital',
  allHospitals: 'All Hospitals',

  popupTitleRequired: 'Please enter popup title',
  popupContentRequired: 'Please enter popup content',
  popupTypeRequired: 'Please select popup type',
  popupTitlePlaceholder: 'Enter popup title',
  popupContentPlaceholder: 'Enter popup content',
  selectPopupType: 'Select popup type',
  selectTargetHospital: 'Select target hospital',

  'popupType.notice': 'Notice',
  'popupType.event': 'Event',
  'popupType.maintenance': 'Maintenance',

  // Status change time
  lastStatusChangeTime: 'Last Status Change Time',
  activationStartTime: 'Activation Start Time',
  deactivationStartTime: 'Deactivation Start Time',
};

export default hospitalTranslation;
